<template>
  <div class="topic">
    <div>
      <div
        :class="[
          'topic__title',
          {
            'topic__title--spacing': item.tags && item.tags.length > 0
          }
        ]"
      >
        {{ item.name }}
      </div>
      <b-taglist v-if="item.tags && item.tags.length > 0">
        <b-tag
          v-for="(tag, tagIndex) in item.tags"
          :key="tagIndex"
          type="is-info"
        >
          {{ tag }}
        </b-tag>
      </b-taglist>
    </div>
    <router-link
      class="button is-link is-small"
      :to="`/topics/edit/${item.id}`"
    >
      Edit
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    item: Object
  }
};
</script>

<style lang="scss" scoped>
.topic {
  display: flex;
  align-items: center;
  justify-content: space-between;

  &__title {
    &--spacing {
      margin-bottom: 0.5rem;
    }
  }
}
</style>
